var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.handleSubmit($event)}}},[_vm._t("default"),_c('button',{ref:"btn",staticStyle:{"display":"none"},attrs:{"type":"submit"}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }